// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classNames from 'classnames';

// Utils
import { chooseSingular } from '../../../../../../../../common/utils/stringUtil';
import { isPlatformModernMobileApp } from '../../../../../../../platform/utils/platformDetailsUtils';

// Actions
import { fetchCurrentBoardPublishedBoardViewers } from './publishedBoardViewersActions';

// Selectors
import {
    currentBoardPublishLinkGuestViewerCountSelector,
    currentBoardPublishLinkViewerCountSelector,
} from './publishedBoardViewersSelector';

// Components
import Icon from '../../../../../../../components/icons/Icon';
import PublishBoardViewersPopup from './PublishBoardViewersPopup';
import PopupTrigger from '../../../../../../../components/popupPanel/PopupTrigger';
import StyledFieldInfoText from '../../../../../../../components/form/fields/StyledFieldInfoText';

// Constants
import { PopupIds } from '../../../../../../../components/popupPanel/popupConstants';

// Styles
import './PublishBoardViewersSection.scss';

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchCurrentBoardPublishedBoardViewers: () => dispatch(fetchCurrentBoardPublishedBoardViewers()),
});

const mapStateToProps = createStructuredSelector({
    publishedViewerCount: currentBoardPublishLinkViewerCountSelector,
    publishedGuestViewerCount: currentBoardPublishLinkGuestViewerCountSelector,
});

const PublishBoardViewersSection = (props) => {
    const {
        dispatchFetchCurrentBoardPublishedBoardViewers,
        publishedViewerCount = 0,
        publishedGuestViewerCount = 0,
        isPublished,
        showSharedAncestorBoardLink,
        platformDetails,
    } = props;

    React.useEffect(() => {
        dispatchFetchCurrentBoardPublishedBoardViewers();
    }, []);

    // Don't show the viewers when on sub-boards of published boards.
    // I'm not 100% sure of the reason for this, but the route does not support it correctly at this stage,
    // so I'll match that behaviour until we decide to fix it.
    if (showSharedAncestorBoardLink) return null;

    // Don't show the viewers on mobile apps
    if (isPlatformModernMobileApp(platformDetails)) return null;

    const totalViewerCount = publishedGuestViewerCount + publishedViewerCount || 0;

    const viewerCountClasses = classNames('publish-board-viewers', { 'no-viewers': !totalViewerCount });

    return (
        <div className={classNames('PublishBoardViewersSection', { disabled: !isPublished })}>
            <Icon name="graph" />
            <StyledFieldInfoText className={viewerCountClasses}>
                <PopupTrigger popupId={PopupIds.PUBLISHED_VIEWERS}>
                    {() => (
                        <span className="published-board-viewer-count">
                            {totalViewerCount} {chooseSingular(totalViewerCount, 'person', 'people')}
                        </span>
                    )}
                </PopupTrigger>
                &nbsp;{chooseSingular(totalViewerCount, 'has', 'have')} viewed this link
            </StyledFieldInfoText>
            <PublishBoardViewersPopup />
        </div>
    );
};

PublishBoardViewersSection.propTypes = {
    currentBoard: PropTypes.object,
    publishedViewerCount: PropTypes.number,
    publishedGuestViewerCount: PropTypes.number,
    isPublished: PropTypes.bool,
    showSharedAncestorBoardLink: PropTypes.bool,
    dispatchFetchCurrentBoardPublishedBoardViewers: PropTypes.func,
    platformDetails: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(PublishBoardViewersSection);
